import { render, staticRenderFns } from "./SuspensionBlocked.vue?vue&type=template&id=4864579c&"
import script from "./SuspensionBlocked.vue?vue&type=script&lang=js&"
export * from "./SuspensionBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports